import { render, staticRenderFns } from "./Ativar.vue?vue&type=template&id=076c3ec2"
import script from "./Ativar.vue?vue&type=script&lang=js"
export * from "./Ativar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports